import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FlowClientSitesListResolver } from '../resolvers/sites-builder.resolver';
import { SbClientComponent } from './sb-client.component';

const routes: Routes = [
  /*   {
    path: '',
    redirectTo: 'sites'
  }, */
  {
    path: '',
    component: SbClientComponent,
    resolve: {
      clientSites: FlowClientSitesListResolver,
    },
    children: [
      {
        path: 'sites',
        component: SbClientComponent,
        resolve: {
          clientSites: FlowClientSitesListResolver,
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SbClientRoutingModule {}
